export default __webpack_public_path__ + "static/media/wave.fc2850fe.svg";